<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/Preface">Preface</a></p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. Good Boys, True to God and Country</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. No Town in the State Can Excel Lansing</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. The Brave Boys Go</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. We Have a Railroad</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. The Best of Friends Must Part</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. The Ladies of Lansing</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. They Fought as Demons</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. Let Those Scars Be an Honor to You</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. The Michigan Female College</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. To the Tented Field</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. The House of Correction for Juvenile Offenders</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">12. They Covered Themselves in Glory</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">13. First in the Regiment</span></p>
<p class="toc"><span href="#/Chapter14#C14" title="Link target outside of Sample">14. Nothing Can Beat the Michigan Soldiers</span></p>
<p class="toc"><span href="#/Chapter15#C15" title="Link target outside of Sample">15. We Have Given of the Best We Have</span></p>
<p class="toc"><span href="#/Chapter16#C16" title="Link target outside of Sample">16. To Live Honored and Die Regretted</span></p>
<p class="toc"><span href="#/Chapter17#C17" title="Link target outside of Sample">17. My Boy’s Not Coming Home</span></p>
<p class="toc1"><span href="#/Appendix" title="Link target outside of Sample">Appendix: Roster of Lansing Soldiers</span></p>
<p class="toc"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?11a550af